import { frontendURL } from 'dashboard/helper/URLHelper';

const EmailMktRouteView = () => import('./pages/EmailMktRouteView.vue');
const EmailCampaignFormPage = () => import('./pages/EmailCampaignFormPage.vue');
const EmailCampaignDetailPage = () =>
  import('./pages/EmailCampaignDetailPage.vue');

const meta = {
  permissions: ['administrator'],
};

const emailMktRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/email-mkt'),
      component: EmailMktRouteView,
      children: [
        {
          // Página standalone aposentada — tudo vive em "Campanhas".
          path: '',
          name: 'email_mkt_index',
          redirect: to => ({ name: 'campaigns_index', params: to.params }),
        },
        {
          path: 'new',
          name: 'email_mkt_new',
          meta,
          component: EmailCampaignFormPage,
        },
        {
          path: ':campaignId/edit',
          name: 'email_mkt_edit',
          meta,
          component: EmailCampaignFormPage,
          props: true,
        },
        {
          path: ':campaignId/report',
          name: 'email_mkt_show',
          meta,
          component: EmailCampaignDetailPage,
          props: true,
        },
      ],
    },
  ],
};

export default emailMktRoutes;
